import axios from 'axios';
import { Dispatch } from 'redux';
import USER_TYPES, {
  ICreateStripeCustomerRequest,
  IStripeCustomerPortalFlowType,
  IStripeCustomerSessionRequest,
} from './types';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';
import { getRefValue, getSiteAccessToken } from 'services/storage';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

export const loginUser =
  (accessToken: string) =>
  async (dispatch: Dispatch): Promise<boolean> => {
    dispatch(USER_TYPES.userStart());
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_LOGIN}`;
    const referred_by = getRefValue();
    const body = referred_by ? { referred_by } : {};

    try {
      const response = await axios.post(url, body, {
        headers: { ...headers, Authorization: `Bearer ${accessToken}` },
      });
      dispatch(USER_TYPES.userSuccess(response.data));
      return true;
    } catch (error: any) {
      dispatch(USER_TYPES.userError(error.message));
      return false;
    }
  };

export const getUserProfile =
  () =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(USER_TYPES.userStart());
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_PROFILE}`;

    try {
      const response = await axios.get(url, {
        headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      });
      dispatch(USER_TYPES.userProfileSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(USER_TYPES.userProfileError(error.message));
      return Promise.reject(error);
    }
  };

export const updateUserProfile =
  body =>
  async (dispatch: Dispatch): Promise<any> => {
    const bodyUpdated =
      body.monthly_budget !== undefined
        ? { ...body, monthly_budget: body.monthly_budget * 100 }
        : body;

    dispatch(USER_TYPES.userStart());
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_PROFILE}`;

    try {
      const response = await axios.patch(url, bodyUpdated, {
        headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      });
      dispatch(USER_TYPES.userProfileSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(USER_TYPES.userProfileError(error.message));
      return Promise.reject(error);
    }
  };

export const postUserStripeCustomer =
  (body: ICreateStripeCustomerRequest) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(USER_TYPES.userStart());
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_STRIPE}`;

    try {
      const response = await axios.post(url, body, {
        headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      });
      dispatch(USER_TYPES.userProfileUpdateSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(USER_TYPES.userProfileError(error.message));
      return Promise.reject(error);
    }
  };

export const postUserStripeCustomerSession = async (body?: IStripeCustomerSessionRequest) => {
  const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_STRIPE_SESSION}`;

  try {
    const response = await axios.post(url, body || {}, {
      headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
    });
    return Promise.resolve(response);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getUserStripeCustomerPortal = async (params: {
  flow_type?: IStripeCustomerPortalFlowType;
  subscription_id?: string;
  return_url: string;
}) => {
  const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_STRIPE_CUSTOMER_PORTAL}`;

  try {
    const response = await axios.get(url, {
      headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      params,
    });
    return Promise.resolve(response);
  } catch (error: any) {
    return Promise.reject(error);
  }
};
